module.exports = __webpack_public_path__ + "img/foto_JPR.bc20bf52.jpg";